import { defineStore } from "pinia";
import { ref } from "vue";

export const useToolTipData = defineStore("tooltipData", () => {
  const tooltipData = ref([]);
  const query = ref(null);

  return { query, tooltipData };
});
